import { RevenuePerMonthSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const GetRevenueChartDataResponseSchema = oz.object({
  revenueChartData: oz.object({
    fixedRevenuePerMonth: RevenuePerMonthSchema,
    usageRevenuePerMonth: RevenuePerMonthSchema,
    deferredRevenuePerMonth: RevenuePerMonthSchema,
  }),
});

export type GetRevenueChartDataResponse = oz.infer<typeof GetRevenueChartDataResponseSchema>;